/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { setApplicationLocalStorageItem } from "../../helpers";

export default {
  SET_CURRENT_MODULE_NAME(state, payload) {
    if (payload === null || payload === undefined) {
      state.currentModuleName = '';
      state.currentModuleNameEn = '';
    } else if (typeof payload === 'object' && !Array.isArray(payload)) {
      state.currentModuleName = payload.module_name || payload.moduleName || '';
      state.currentModuleNameEn = payload.module_name_en || payload.moduleNameEn || '';
    } else {
      state.currentModuleName = payload;
      state.currentModuleNameEn = '';
    }
  },
  SET_TOKEN(state, accessToken) {
    // axios.defaults.headers.common['Authorization'] = `${accessToken}`
    state.token = accessToken;
  },
  SET_API_URL(state, url) {
    state.api_url = url;
  },
  SET_DELEGATOR_URL(state, url) {
    state.delegator_url = url;
  },
  SET_APP_TOKEN(state, token) {
    state.app_token = token;
  },
  SET_USE_MICROSOFT_SSO(state, use_microsoft_sso) {
    state.use_microsoft_sso = use_microsoft_sso;
  },
  SET_MICROSOFT_CLIENT_ID(state, client_id) {
    state.microsoft_client_id = client_id;
  },
  SET_MICROSOFT_TENANT_ID(state, tenant_id) {
    state.microsoft_tenant_id = tenant_id;
  },
  SET_MICROSOFT_REDIRECT_URL(state, redirect_url) {
    state.microsoft_redirect_url = redirect_url;
  },
  SET_API_INTEGRATION_TOKEN(state, token) {
    state.api_integration_token = token;
  },
  SET_LOGIN_PARAMETERS(state, parameters) {
    state.login_parameters = parameters;
  },
  SET_USER(state, user) {
    state.user = user;
  },
  SET_LAYOUT(state, layout) {
    state.layout = layout;
  },
  SET_GENERAL(state, general) {
    state.general = general;
  },
  SET_USER_ROLE(state, role) {
    state.role = role;
  },
  SET_ROLE_LOGO(state, logo) {
    state.roleLogo = logo;
  },
  SET_ROLE_LOGO_HEIGHT(state, height) {
    state.roleLogoHeight = height;
  },
  SET_USER_NAME(state, name) {
    state.user.name = name;
  },
  SET_USER_USERNAME(state, username) {
    state.user.username = username;
  },
  SET_USER_PHOTO(state, photo) {
    state.user.photo = photo;
  },
  SET_USER_MOBILE(state, mobile) {
    state.user.mobile = mobile;
  },
  SET_APPLICATION_LANGUAGES(state, languages) {
    state.languages = languages;
  },
  SET_APPLICATION_MENU(state, menu) {
    if (typeof menu === "string") {
      state.menu = JSON.parse(menu);
    } else {
      state.menu = menu;
    }
  },
  ADD_APPLICATION_MENU_ANCHOR(state, item) {
    state.menu.push(item);
  },
  ADD_APPLICATION_MENU_GROUP(state, itemPayload) {
    const parentHash = itemPayload.parentHash;
    const hash = itemPayload.hash;
    const name = itemPayload.name;
    const url = itemPayload.url;
    const icon = itemPayload.icon;

    state.menu.forEach(item => {
      if (item.hash === parentHash) {
        item.items.push({
          hash: hash,
          name: name,
          slug: name.replace(" ", "-").toLowerCase(),
          url: url,
          icon: icon,
          submenu: []
        });
      } else {
        item.items.forEach(itemLevel2 => {
          if (itemLevel2.hash === parentHash) {
            itemLevel2.submenu.push({
              hash: hash,
              name: name,
              slug: name.replace(" ", "-").toLowerCase(),
              url: url,
              icon: icon,
              submenu: []
            });

            return;
          }
        });
      }
    });

    state.menuLayout.forEach(item => {
      if (item.hash === parentHash) {
        item.items.push({
          hash: hash,
          name: name,
          slug: name.replace(" ", "-").toLowerCase(),
          url: url,
          icon: icon,
          submenu: []
        });
      } else {
        item.items.forEach(itemLevel2 => {
          if (itemLevel2.hash === parentHash) {
            itemLevel2.submenu.push({
              hash: hash,
              name: name,
              slug: name.replace(" ", "-").toLowerCase(),
              url: url,
              icon: icon,
              submenu: []
            });

            return;
          }
        });
      }
    });
  },
  SET_MENU_ICON(state, itemPayload) {
    const itemHash = itemPayload.hash;
    const itemIcon = itemPayload.icon;

    state.menu.forEach((item, index) => {
      if (item.hasOwnProperty("items")) {
        item.items.forEach((itemLevel2, indexLevel2) => {
          if (itemLevel2.hash === itemHash) {
            state.menu[index].items[indexLevel2].icon = itemIcon;
            return;
          } else {
            if (itemLevel2.hasOwnProperty("submenu")) {
              itemLevel2.submenu.forEach((itemLevel3, indexLevel3) => {
                if (itemLevel3.hash === itemHash) {
                  state.menu[index].items[indexLevel2].submenu[
                    indexLevel3
                  ].icon = itemIcon;
                  return;
                } else {
                  if (itemLevel3.hasOwnProperty("submenu")) {
                    itemLevel3.submenu.forEach((itemLevel4, indexLevel4) => {
                      if (itemLevel4.hash === itemHash) {
                        state.menu[index].items[indexLevel2].submenu[
                          indexLevel3
                        ].submenu[indexLevel4].icon = itemIcon;
                        return;
                      }
                    });
                  }
                }
              });
            }
          }
        });
      }
    });

    state.menuLayout.forEach((item, index) => {
      if (item.hasOwnProperty("items")) {
        item.items.forEach((itemLevel2, indexLevel2) => {
          if (itemLevel2.hash === itemHash) {
            state.menuLayout[index].items[indexLevel2].icon = itemIcon;
            return;
          } else {
            if (itemLevel2.hasOwnProperty("submenu")) {
              itemLevel2.submenu.forEach((itemLevel3, indexLevel3) => {
                if (itemLevel3.hash === itemHash) {
                  state.menuLayout[index].items[indexLevel2].submenu[
                    indexLevel3
                  ].icon = itemIcon;
                  return;
                } else {
                  if (itemLevel3.hasOwnProperty("submenu")) {
                    itemLevel3.submenu.forEach((itemLevel4, indexLevel4) => {
                      if (itemLevel4.hash === itemHash) {
                        state.menuLayout[index].items[indexLevel2].submenu[
                          indexLevel3
                        ].submenu[indexLevel4].icon = itemIcon;
                        return;
                      }
                    });
                  }
                }
              });
            }
          }
        });
      }
    });
  },
  async ADD_APPLICATION_MENU_ITEM(state, itemPayload) {
    return new Promise((resolve, reject) => {
      const parentHash = itemPayload.parentHash;
      const itemHash = itemPayload.hash;
      const itemName = itemPayload.name;
      const itemUrl = itemPayload.url;
      const itemIcon = itemPayload.icon;

      let itemIndex = 0;

      if (itemPayload.hasOwnProperty("index")) {
        itemIndex = itemPayload.index;
      }

      let itemSubmenu = [];

      if (itemPayload.hasOwnProperty("submenu")) {
        itemSubmenu = itemPayload.submenu;
      }

      let finish = false;

      state.menu.forEach(item => {
        if (!finish) {
          if (item.hash === parentHash) {
            const itemObject = {
              hash: itemHash,
              name: itemName,
              slug: itemName.replace(" ", "-").toLowerCase(),
              url: itemUrl,
              icon: itemIcon
            };

            if (itemSubmenu.length > 0) {
              itemObject["submenu"] = itemSubmenu;
            }

            // item.items.push(itemObject)
            // this.clearMenu(item.items)
            item.items.splice(itemIndex, 0, itemObject);
            finish = true;
          } else {
            item.items.forEach(itemLevel2 => {
              if (itemLevel2.hash === parentHash) {
                if (!finish) {
                  const itemObject = {
                    hash: itemHash,
                    name: itemName,
                    slug: itemName.replace(" ", "-").toLowerCase(),
                    icon: itemIcon,
                    url: itemUrl
                  };

                  if (itemSubmenu.length > 0) {
                    itemObject["submenu"] = itemSubmenu;
                  }

                  const indexList = itemLevel2.submenu.filter(
                    x => x.remove === true
                  );

                  indexList.forEach(item => {
                    const itemIndex = itemLevel2.submenu.indexOf(item);

                    itemLevel2.submenu.splice(itemIndex, 1);
                  });

                  // this.clearMenu(itemLevel2.submenu)

                  itemLevel2.submenu.push(itemObject);
                  // itemLevel2.submenu.splice(itemIndex, 0, itemObject)

                  finish = true;
                }
              } else {
                // console.log('here')
                // return
                if (itemLevel2.hasOwnProperty("submenu")) {
                  itemLevel2.submenu.forEach(itemLevel3 => {
                    if (!finish) {
                      if (itemLevel3.hash === parentHash) {
                        const itemObject = {
                          hash: itemHash,
                          name: itemName,
                          icon: "MailIcon",
                          slug: itemName.replace(" ", "-").toLowerCase(),
                          url: itemUrl,
                          remove: false
                        };

                        if (itemSubmenu.length > 0) {
                          itemObject["submenu"] = itemSubmenu;
                        }

                        const indexList = itemLevel3.submenu.filter(
                          x => x.remove === true
                        );

                        indexList.forEach(item => {
                          const itemIndex = itemLevel3.submenu.indexOf(item);

                          itemLevel3.submenu.splice(itemIndex, 1);
                        });

                        itemLevel3.submenu.push(itemObject);
                        // itemLevel3.submenu.splice(itemIndex, 0, itemObject)

                        finish = true;
                      }
                    }
                  });
                }
              }
            });
          }
        }
      });

      state.menuLayout.forEach(item => {
        if (item.hash === parentHash) {
          const itemObject = {
            hash: itemHash,
            name: itemName,
            slug: itemName.replace(" ", "-").toLowerCase(),
            url: itemUrl,
            icon: itemIcon
          };

          if (itemSubmenu.length > 0) {
            itemObject["submenu"] = itemSubmenu;
          }

          // item.items.push(itemObject)
          item.items.splice(itemIndex, 0, itemObject);
        } else {
          item.items.forEach(itemLevel2 => {
            if (itemLevel2.hash === parentHash) {
              const itemObject = {
                hash: itemHash,
                name: itemName,
                slug: itemName.replace(" ", "-").toLowerCase(),
                url: itemUrl
              };

              if (itemSubmenu.length > 0) {
                itemObject["submenu"] = itemSubmenu;
              }

              const indexList = itemLevel2.submenu.filter(
                x => x.remove === true
              );

              indexList.forEach(item => {
                const itemIndex = itemLevel2.submenu.indexOf(item);

                itemLevel2.submenu.splice(itemIndex, 1);
              });

              itemLevel2.submenu.push(itemObject);
              // itemLevel2.submenu.splice(itemIndex, 0, itemObject)

              return;
            } else {
              if (itemLevel2.hasOwnProperty("submenu")) {
                itemLevel2.submenu.forEach(itemLevel3 => {
                  if (itemLevel3.hash === parentHash) {
                    const itemObject = {
                      hash: itemHash,
                      name: itemName,
                      slug: itemName.replace(" ", "-").toLowerCase(),
                      url: itemUrl,
                      remove: false
                    };

                    if (itemSubmenu.length > 0) {
                      itemObject["submenu"] = itemSubmenu;
                    }

                    const indexList = itemLevel3.submenu.filter(
                      x => x.remove === true
                    );

                    indexList.forEach(item => {
                      const itemIndex = itemLevel3.submenu.indexOf(item);

                      itemLevel3.submenu.splice(itemIndex, 1);
                    });

                    itemLevel3.submenu.push(itemObject);
                    // itemLevel3.submenu.splice(itemIndex, 0, itemObject)
                  }
                });
              }
            }
          });
        }
      });

      const newMenuLayout = JSON.parse(JSON.stringify(state.menuLayout));
      const newMenu = JSON.parse(JSON.stringify(state.menu));

      state.menuLayout = [];
      state.menu = [];

      setTimeout(() => {
        state.menuLayout = JSON.parse(JSON.stringify(newMenuLayout));
        state.menu = JSON.parse(JSON.stringify(newMenu));
        resolve(true);
      }, 300);
    });
  },
  GET_ITEM_DETAIL(state, payload) {
    const itemHash = payload.hash;

    state.menu.forEach((item, index) => {
      if (item.hash === itemHash) {
        return state.menu[index];
      } else {
        if (item.hasOwnProperty("items")) {
          item.items.forEach((itemLevel2, indexLevel2) => {
            if (itemLevel2.hash === itemHash) {
              return state.menu[index].items[indexLevel2];
            } else {
              if (itemLevel2.hasOwnProperty("submenu")) {
                itemLevel2.submenu.forEach((itemLevel3, indexLevel3) => {
                  if (itemLevel3.hash === itemHash) {
                    return state.menu[index].items[indexLevel2].submenu[
                      indexLevel3
                    ];
                  } else {
                    if (itemLevel3.hasOwnProperty("submenu")) {
                      itemLevel3.submenu.forEach((itemLevel4, indexLevel4) => {
                        if (itemLevel4.hash === itemHash) {
                          return state.menu[index].items[indexLevel2].submenu[
                            indexLevel3
                          ].submenu[indexLevel4];
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }
      }
    });
  },
  SET_MENU_NAME(state, payload) {
    const itemHash = payload.hash;
    const itemName = payload.name;

    state.menu.forEach((item, index) => {
      if (item.hash === itemHash) {
        state.menu[index].header = payload.name;
        return;
      } else {
        if (item.hasOwnProperty("items")) {
          item.items.forEach((itemLevel2, indexLevel2) => {
            if (itemLevel2.hash === itemHash) {
              state.menu[index].items[indexLevel2].name = itemName;
              return;
            } else {
              if (itemLevel2.hasOwnProperty("submenu")) {
                itemLevel2.submenu.forEach((itemLevel3, indexLevel3) => {
                  if (itemLevel3.hash === itemHash) {
                    state.menu[index].items[indexLevel2].submenu[
                      indexLevel3
                    ].name = itemName;
                    return;
                  } else {
                    if (itemLevel3.hasOwnProperty("submenu")) {
                      itemLevel3.submenu.forEach((itemLevel4, indexLevel4) => {
                        if (itemLevel4.hash === itemHash) {
                          state.menu[index].items[indexLevel2].submenu[
                            indexLevel3
                          ].submenu[indexLevel4].name = itemName;
                          return;
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }
      }
    });
  },
  REMOVE_APPLICATION_MENU_ITEM(state, itemHash) {
    state.menu.forEach((item, index) => {
      if (item.hash === itemHash) {
        state.menu.splice(index, 1);
        return;
      } else {
        if (item.hasOwnProperty("items")) {
          item.items.forEach((itemLevel2, indexLevel2) => {
            if (itemLevel2.hash === itemHash) {
              state.menu[index].items.splice(indexLevel2, 1);
              return;
            } else {
              if (itemLevel2.hasOwnProperty("submenu")) {
                itemLevel2.submenu.forEach((itemLevel3, indexLevel3) => {
                  if (itemLevel3.hash === itemHash) {
                    state.menu[index].items[indexLevel2].submenu.splice(
                      indexLevel3,
                      1
                    );
                    return;
                  } else {
                    if (itemLevel3.hasOwnProperty("submenu")) {
                      itemLevel3.submenu.forEach((itemLevel4, indexLevel4) => {
                        if (itemLevel4.hash === itemHash) {
                          state.menu[index].items[indexLevel2].submenu[
                            indexLevel3
                          ].submenu.splice(indexLevel4, 1);
                          return;
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }
      }
    });
  },
  ADD_REMOVE_TAG(state, itemHash) {
    state.menu.forEach((item, index) => {
      if (item.hash === itemHash) {
        // state.menu[index].remove = true
        state.menu.splice(index, 1);
        return;
      } else {
        if (item.hasOwnProperty("items")) {
          item.items.forEach((itemLevel2, indexLevel2) => {
            if (itemLevel2.hash === itemHash) {
              state.menu[index].items.splice(indexLevel2, 1);
              return;
            } else {
              if (itemLevel2.hasOwnProperty("submenu")) {
                itemLevel2.submenu.forEach((itemLevel3, indexLevel3) => {
                  if (itemLevel3.hash === itemHash) {
                    if (indexLevel3 === 0) {
                      state.menu[index].items[indexLevel2].submenu.shift();
                    } else {
                      state.menu[index].items[indexLevel2].submenu.splice(
                        indexLevel3,
                        1
                      );
                    }

                    // console.log(state.menu[index].items[indexLevel2])
                    return;
                  } else {
                    if (itemLevel3.hasOwnProperty("submenu")) {
                      itemLevel3.submenu.forEach((itemLevel4, indexLevel4) => {
                        if (itemLevel4.hash === itemHash) {
                          // state.menu[index].items[indexLevel2].submenu[indexLevel3].submenu[indexLevel4].remove = true

                          state.menu[index].items[indexLevel2].submenu[
                            indexLevel3
                          ].submenu.splice(indexLevel4, 1);
                          return;
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }
      }
    });
  },
  SORT_MENU_LIST(state, indexList) {
    const mapped = state.menu.map((item, index) => {
      item.items.map(itemLevel2 => {
        if (itemLevel2.hasOwnProperty("submenu")) {
          itemLevel2.submenu.map(itemLevel3 => {
            if (itemLevel3.hasOwnProperty("submenu")) {
              itemLevel3.submenu.map(itemLevel4 => {
                if (indexList.hasOwnProperty(itemLevel4.hash)) {
                  itemLevel4["index"] = indexList[itemLevel4.hash].index;
                  return itemLevel4;
                }
              });
            }

            if (indexList.hasOwnProperty(itemLevel3.hash)) {
              itemLevel3["index"] = indexList[itemLevel3.hash].index;
              return itemLevel3;
            }
          });
        }

        if (indexList.hasOwnProperty(itemLevel2.hash)) {
          itemLevel2["index"] = indexList[itemLevel2.hash].index;

          return itemLevel2;
        }
      });

      if (indexList.hasOwnProperty(item.hash)) {
        item["index"] = indexList[item.hash].index;
        return item;
      }
    });

    let newMapped = [];

    mapped.forEach(item => {
      newMapped.push(item);
    });

    newMapped = JSON.parse(JSON.stringify(newMapped));

    newMapped.forEach(item => {
      if (item.hasOwnProperty("items")) {
        item.items.forEach(itemLevel2 => {
          if (itemLevel2.hasOwnProperty("submenu")) {
            itemLevel2.submenu.forEach(itemLevel3 => {
              if (itemLevel3.hasOwnProperty("submenu")) {
                itemLevel3.submenu.sort((a, b) => {
                  return a.index - b.index;
                });
              }
            });
            itemLevel2.submenu.sort((a, b) => {
              return a.index - b.index;
            });
          }
        });
        item.items.sort((a, b) => {
          return a.index - b.index;
        });
      }
    });

    newMapped.sort((a, b) => {
      return a.index - b.index;
    });

    //Clear Items to Remove

    newMapped.forEach((item, itemIndex) => {
      if (item.hasOwnProperty("items")) {
        item.items.forEach((itemLevel2, itemLevel2Index) => {
          if (itemLevel2.hasOwnProperty("submenu")) {
            itemLevel2.submenu.forEach((itemLevel3, itemLevel3Index) => {
              if (itemLevel3.hasOwnProperty("submenu")) {
                itemLevel3.submenu.forEach((itemLevel4, itemLevel4Index) => {
                  if (
                    itemLevel4.hasOwnProperty("remove") &&
                    itemLevel4.remove
                  ) {
                    itemLevel3.submenu.splice(itemLevel4Index, 1);
                  }
                });
              }
              if (itemLevel3.hasOwnProperty("remove") && itemLevel3.remove) {
                itemLevel2.submenu.splice(itemLevel3Index, 1);
              }
            });
          }
          if (itemLevel2.hasOwnProperty("remove") && itemLevel2.remove) {
            item.items.splice(itemLevel2Index, 1);
          }
        });
      }
      if (item.hasOwnProperty("remove") && item.remove) {
        newMapped.splice(itemIndex, 1);
      }
    });

    state.menuLayout = newMapped;

    setApplicationLocalStorageItem("menuLayout", JSON.stringify(newMapped));
  },
  SET_MENU_LAYOUT(state, menu) {
    state.menuLayout = menu;
  },
  SET_APPLICATION_WEB_PARAMETERS(state, web) {
    state.web = web;
  },
  SET_ADMIN_MENU(state, menu) {
    state.adminMenu = menu;
  },
  SET_AVAILABLE_ROLES(state, roles) {
    state.availableRoles = roles;
  },
  clearMenu(item) {
    // console.log(item);
  }
};
